import { RedirectError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';

import logError from './logging';
import type { RedirectStatusCode } from './types';

/**
 * Redirects, using a server-issued 3xx HTTP response if possible.
 * Local development note: If redirectUri is external, you will need to comment out a couple lines from WebpackRouter.js (do not commit!): https://github.com/webedx-spark/web/blob/4ef933d8a36f3b29062595879179ad912f5f7269/lib/WebpackRouter.js#L316
 */
export const performRedirect = (redirectUri: string, statusCode: RedirectStatusCode): void => {
  if (inServerContext) {
    throw new RedirectError(statusCode, redirectUri);
  } else {
    // This code is running in the browser, likely due to unexpected SSR failure
    logError(`Redirect was not performed by 301/302 HTTP response from SSR for URL ${redirectUri}`);
    window.location.replace(redirectUri);
    // Not using setLocation() from coursera.redirect.js here because it only allows redirects for the same domain
  }
};
